<template>
    <v-checkbox
        :value="value"
        class="body-2 mt-0 mb-6"
        name="tosAndGDPRAgreement"
        :aria-label="$t('form.terms')"
        hide-details
        id="tosAndGDPRAgreement"
        @change="$emit('handleTermsAndConditionsCheckbox', $event)"
    >
        <template v-slot:label>
            <div @click.stop v-html="getTermText" />
        </template>
    </v-checkbox>
</template>
<script>
import { inferConsentDomain } from '@/helpers/env';
import { formRules } from '@/mixins/form-rules';
import { MIN_AGE_TO_BOOK_IN_APP } from '@/config';

export default {
    name: 'terms-and-conditions',
    props: {
        value: { type: Boolean, required: true },
        isOwner: { type: Boolean, required: true },
    },
    mixins: [formRules],
    computed: {
        privacyPolicyLink() {
            return '//' + inferConsentDomain() + this.$t('form.policyLink');
        },
        termsAndConditionLink() {
            return '//' + inferConsentDomain() + this.$t('form.termsLink');
        },
        getPreTermText() {
            return this.$t('form.preTermsText', [MIN_AGE_TO_BOOK_IN_APP]);
        },
        getTermText() {
            return this.isOwner ? this.$t('form.ownerTermsText', [this.termsAndConditionLink, MIN_AGE_TO_BOOK_IN_APP]) : this.$t('form.otherTermsText', [this.termsAndConditionLink, MIN_AGE_TO_BOOK_IN_APP]);
        },
    },
};
</script>
